<div *ngIf="parentForm" [formGroup]="parentForm" class="app-footer">
    <div *ngIf="isHelp===true" class="modal-general">
        <qbe-help-modal helpButtonText="{{ 'callMeBack.helpButton' | translate}}"
            callBackButtonText="{{ 'callMeBack.callMeBackHeader' | translate}}"
            guidebookButtonText="{{ 'callMeBack.guidebookButton' | translate}}"
            [oldVersion]="fromCustPortal=== true || fromAgentPage=== true" [showChatButton]="false" #helpModal
            (buttonClicked)="setCallMeBack()">
            <qbe-help-modal-group>
                <qbe-help-modal-content *ngFor="let title of titles" title={{title.question}}>
                    {{title.answer}}
                </qbe-help-modal-content>
            </qbe-help-modal-group>
            <div class="cpc-help-modal_phone">
                <span class="cpc-help-modal_phone-bold">
                    {{'footer.phoneText'
                    | translate}}
                </span> {{'footer.callUsText' | translate}}
                <a href="tel:0700 13 014" class="cpc-help-modal_phone-link">
                    +359
                    700 13 014
                </a>
            </div>


            <div callback-left-col>


                <div class="container-blue">
                    <h3 class="call-me-back-headline">
                        {{ 'callMeBack.callMeBackHeader' | translate}}
                    </h3>
                    <div class="do-you-need-assistan-text">
                        <p>
                            {{ 'callMeBack.needAssistance' | translate}}
                        </p>
                        <b style="margin-top: 15px;">
                            {{
                            'callMeBack.standartWorkTime' | translate}}
                        </b>
                    </div>
                    <div class="working-time-text" nxRow>
                        <p class="time">{{ 'callMeBack.Mon-Fri' | translate}}:</p>
                        <p class="time-hours">9:00 - 17:00</p>
                    </div>
                    <div class="woman-img" [ngClass]="{'activatedImg':chosenSchedule===true}">
                        <qbe-illustration name="womanWithLaptopTalkingOnThePhoneWithPlant" width="264px"></qbe-illustration>
                    </div>
                </div>




            </div>
            <form callback-right-col [formGroup]="emailForm" (ngSubmit)="submitButton()"
                [appInvalidControlScroll]="emailForm">


                <div class="content-white">
                    <nx-formfield label="{{'callMeBack.name' | translate}}" style="margin-top: 48px;">
                        <input required formControlName="name" nxInput pattern="[a-zA-Zа-яА-ЯЁё\s-]*" class="inputField"
                            (change)="this.trackService.checkErrors(this.emailForm.controls.name, 'User name')">
                    </nx-formfield>
                    <nx-error *ngIf="(this.emailForm.get('name').errors && this.emailForm.get('name').touched===true) "
                        class="field-error" appearance="text">
                        {{ "callMeBack.validName" | translate }}
                    </nx-error>
                    <nx-formfield label="{{'callMeBack.email'| translate}}">
                        <input nxInput formControlName="email" pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,5}"
                            (change)="this.trackService.pushEventTracking('user.emailAdress', this.emailForm.controls.email.value)"
                            (change)="this.trackService.checkErrors( this.emailForm.controls.email, 'User email address')"
                            class="inputField">
                        <!-- <span nxFormfieldHint>  email@domainname.com</span> -->
                    </nx-formfield>
                    <nx-error
                        *ngIf="(this.emailForm.get('email').errors && this.emailForm.get('email').touched===true) "
                        class="field-error" appearance="text">
                        {{ "callMeBack.validMail" | translate }}
                    </nx-error>
         
                  <!-- <nx-formfield>
                      <nx-dropdown [showFilter]="true" class="phone-code" formControlName="countryCode">
                          <nx-dropdown-item *ngFor="let item of phoneCodes" [value]="'+' + item" (click)="this.trackService.pushEventTracking('user.mobilePhone', this.emailForm.get('countryCode').value+this.emailForm.get('mobile').value)">
                              {{ "+" + item }}
                          </nx-dropdown-item>
                      </nx-dropdown>
                      <input class="input-padding" *ngIf="this.emailForm.get('countryCode').value==='+359'" maxlength='15' [nxMask]="phoneMask" [separators]="phoneSeparator" [dropSpecialCharacters]="true"
                      [pattern]="phonePattern" type="text" nxInput formControlName="mobile" placeholder="{{ 'callMeBack.phoneNumber' | translate}}"
                      (blur)="this.trackService.pushEventTracking('user.mobilePhone', this.emailForm.get('countryCode').value + this.emailForm.get('mobile').value)"
                      (change)="this.trackService.checkErrors(this.emailForm.get('mobile'), 'User mobile number')"
                      />
                      <input class="input-padding" *ngIf="this.emailForm.get('countryCode').value!=='+359'" maxlength='15' [separators]="phoneSeparator" [dropSpecialCharacters]="true"
                      [pattern]="phonePattern" type="text" nxInput formControlName="mobile" placeholder="{{ 'callMeBack.phoneNumber' | translate}}"
                      (blur)="this.trackService.pushEventTracking('user.mobilePhone', this.emailForm.get('countryCode').value + this.emailForm.get('mobile').value)"
                      (change)="this.trackService.checkErrors(this.emailForm.get('mobile'), 'User mobile number')"
                      />
                    </nx-formfield> -->


                    <nx-formfield class="nx-margin-bottom-xs">
                        <app-phone-numbers [mobilePhone]="mobile" [mobileCode]="countryCode" trackingPath="user.mobilePhone" >
                        </app-phone-numbers>
                        <span nxFormfieldHint>+35988 488 76xx</span>
            
                    </nx-formfield>

                    <!-- <nx-error
                        *ngIf="(this.emailForm.get('mobile').errors && this.emailForm.get('mobile').touched===true) "
                        class="field-error" appearance="text">
                        {{ "error.errorMessage" | translate }}
                    </nx-error> -->
                    <nx-radio-group>
                        <nx-radio labelSize="small" [nxChecked]="1" (valueChange)="chooseSchedule()">
                            {{ 'callMeBack.callMeBackNow' | translate}}
                        </nx-radio>
                        <nx-radio labelSize="small" [value]="0" (valueChange)="chooseSchedule()">
                            {{ 'callMeBack.scheduleACall' | translate}}
                        </nx-radio>
                    </nx-radio-group>
                    <div *ngIf="chosenSchedule">
                        <nx-formfield label="{{'callMeBack.date' |
                          translate}}">
                            <input #formatDatefield="nxDatefield" nxDisplayFormat="DD.MM.YYYY"
                                [parseFormat]="['DD/MM/YYYY', 'DD.MM.YYYY', 'DD,MM,YYYY', 'DD-MM-YYYY', 'DDMMYYYY']"
                                formControlName="date" [min]="minDate" [max]="maxDate"
                                [nxDatefieldFilter]="onlyWeekdays" ngModel nxDatefield nxInput
                                [datepicker]="scheduleCall"
                                (dateChange)="trackService.addAttribute('callMeBack.date',(emailForm.controls.date.value).format('YYYY-MM-DD'))">
                            <nx-datepicker-toggle [for]="scheduleCall" nxFormfieldSuffix></nx-datepicker-toggle>
                            <nx-datepicker #scheduleCall></nx-datepicker>
                        </nx-formfield>
                        <nx-formfield label="{{'callMeBack.hour' |
                          translate}}">
                            <nx-dropdown formControlName="hour">
                                <nx-dropdown-item *ngFor="let hour of hours" [value]="hour"
                                    (click)="trackService.addAttribute('callMeBack.hour', emailForm.controls.hour.value )"></nx-dropdown-item>
                            </nx-dropdown>
                        </nx-formfield>
                    </div>
                </div>
                <ng-content></ng-content>


                <center>
                    <button nxButton="primary" type="submit" class="submit-button" [disabled]="submitDisabled">
                        {{ 'callMeBack.submit' | translate}}
                    </button>
                </center>
            </form>
        </qbe-help-modal>
    </div>
    <ng-container *ngIf="footerWithPrice">
        <ng-container *ngIf="{productTypes: sharedService.productTypes$ |
          async,
          currency: sharedService.getCurrency() | async} as o">
            <ng-container *ngIf="(proposalService.calculatedPremiums$ |
              async |
              convertPremiums : parentForm: o.productTypes) as
              calculatedPremiums">
                <ng-container *ngIf="sharedService.calculatePremiums$ |
                  async as
                  productProposals">
                    <ng-container *ngIf="(proposalService.calculatedPremiums$ |
                      async | convertPremiums : parentForm:
                      o.productTypes) |
                      selectedPlan : parentForm as item">
                      <div class="app-footer__buttons">
                          <qbe-button *ngIf="isPaymentScreen()" (click)="openSaveDialog(productProposals,
                              item)" (click)="this.trackService.pushEventTracking('navigationButton', 'SAVE_QUOTE_BUTTON')"  [mode]="'secondary'" class="nextBtnStyle
                              hideOnMobile">
                                {{'footer.saveQuote' | translate}}
                            </qbe-button>
                            <qbe-button (click)="openAgentDialog()"
                                (click)="this.trackService.pushEventTracking('navigationButton', 'MEET_AGENT_BUTTON')"
                                [mode]="'secondary'" class="nextBtnStyle
                              hideOnMobile" *ngIf='fromAgentPage=== true'>
                                {{'footer.meetAgent' | translate}}
                            </qbe-button>
                        </div>



                        <div class="app-footer__right-column">
                            <div class="app-footer_content">
                                <div class="firstContainerRightBottomAmount">
                                    <ng-container *ngIf="parentForm.value.selectedPayments
                                      == 1">
                                      <h4 class="totalPrice totalPriceFooter displayOnMobile">
                                        {{'footer.totalPriceTitle' | translate}}
                                    </h4>
                                        <div class="priceRow">
                                            <h4 class="totalPrice hideOnMobile">
                                                {{'footer.totalPriceTitle' | translate}}
                                            </h4>
                                            <span class="amount">
                                                {{(policyFirstInstallment
                                                ||
                                                getSelectedSum(calculatedPremiums,
                                                item.packageRisks.packageName,
                                                parentForm?.controls?.selectedPayments?.value))
                                                | priceFormat : ((sharedService.getCurrency() | async).main | translate)}}
                                            </span>
                                            <span class="euro-amount" *ngIf="sharedService.showDoubleVisualizationSums() | async"> / {{policyFirstInstallmentEuro
                                                ||getSelectedSumEuro(calculatedPremiums,
                                                item.packageRisks.packageName,
                                                parentForm?.controls?.selectedPayments?.value)| priceFormat : ((sharedService.getCurrency() | async).second | translate)}}
                                            </span>
                                            <span>
                                                {{('footer.pricePeriod' +
                                                parentForm.value.selectedPayments)
                                                | translate}}
                                            </span>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="parentForm.value.selectedPayments
                                      != 1">
                                      <h4 class="totalPrice totalPriceFooter displayOnMobile">
                                        {{'footer.totalPriceTitle' | translate}}
                                    </h4>
                                        <div class="priceRow">
                                            <h4 class="totalPrice hideOnMobile">
                                                {{'footer.totalPriceTitle' | translate}}
                                            </h4>
                                            <span class="amount">
                                                {{(policyFirstInstallment
                                                ||
                                                getSelectedSum(calculatedPremiums,
                                                item.packageRisks.packageName,
                                                parentForm?.controls?.selectedPayments?.value))
                                                | priceFormat : ((sharedService.getCurrency() | async).main | translate)}}
                                            </span>
                                            <span class="euro-amount" *ngIf="sharedService.showDoubleVisualizationSums() | async"> / {{policyFirstInstallmentEuro
                                                || getSelectedSumEuro(calculatedPremiums,
                                                item.packageRisks.packageName,
                                                parentForm?.controls?.selectedPayments?.value) | priceFormat : ((sharedService.getCurrency() | async).second | translate)}}
                                            </span>
                                            <span>
                                                {{('footer.pricePeriod' +
                                                parentForm.value.selectedPayments)
                                                | translate}}
                                            </span>
                                        </div>
                                        <div class="priceRow">
                                            <h4 class="totalPrice
                                              hideOnMobile
                                              hiddenLabel
                                              hiddenLabelMobile">
                                                {{('footer.totalPriceTitle') | translate}}
                                            </h4>
                                            <div class="amount">
                                                {{item.bottomNetPremium | priceFormat : ((sharedService.getCurrency() | async).main | translate)}}
                                            </div>
                                            <span class="euro-amount" *ngIf="sharedService.showDoubleVisualizationSums() | async">/ {{item.bottomNetPremiumEuro | priceFormat : ((sharedService.getCurrency() | async).second | translate)}}</span>
                                            <span>{{'footer.year' |
                                                translate}}</span>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <ng-container *ngFor="let rightButton of
                              rightButtonsList">
                                <qbe-button *ngIf="(!rightButton.type ||
                                  rightButton.type ===
                                  'button') && (forseDisable ||
                                  getState(rightButton.disabled))" (click)="invokeReCaptcha();
                                  sharedService.nextClicks.next();activeFunction(forseDisable
                                  || getState(rightButton.disabled), rightButton.link)" class="nextBtnStyle"
                                    [mode]="'primary'" [noHorizontalMargin]="true"
                                    (click)="this.trackService.pushEventTracking('navigationButton', rightButton.trackingName)"
                                    [state]="{
                                  data: item,
                                  exchange:
                                  parentForm.controls.exchange.value
                                  ? productProposals?.exchangeRateEUR : 1,
                                  proposalList:
                                  productProposals?.proposalList,
                                  insuranceSumNew:
                                  productProposals?.insuranceSumNew,
                                  calculatedPremiums: calculatedPremiums
                                  }">
                                    {{ rightButton.text | translate }}
                                </qbe-button>
                                <qbe-button *ngIf="(!rightButton.type ||
                                  rightButton.type ===
                                  'button') && !(forseDisable ||
                                  getState(rightButton.disabled))" (click)="invokeReCaptcha();
                                  sharedService.nextClicks.next();activeFunction(forseDisable
                                  || getState(rightButton.disabled), rightButton.link)" class="nextBtnStyle"
                                    [mode]="'primary'" [noHorizontalMargin]="true"
                                    (click)="this.trackService.pushEventTracking('navigationButton', rightButton.trackingName)"
                                    [state]="{
                                  data: item,
                                  exchange:
                                  parentForm.controls.exchange.value
                                  ? productProposals?.exchangeRateEUR : 1,
                                  proposalList:
                                  productProposals?.proposalList,
                                  insuranceSumNew:
                                  productProposals?.insuranceSumNew,
                                  calculatedPremiums: calculatedPremiums
                                  }"  >
                                  {{ rightButton.text | translate }}
                              </qbe-button>
                          </ng-container>
                          <div class="mobileFooterFlex displayOnMobile
                              saveMeetContainer">
                              <button *ngIf="isPaymentScreen()" (click)="openSaveDialog(productProposals,
                                  item)" (click)="this.trackService.pushEventTracking('navigationButton', 'SAVE_QUOTE_BUTTON')" nxPlainButton type="button">
                                  <nx-icon
                                      class="buttonIcon"
                                      name="download"></nx-icon>
                                  {{'footer.saveQuote' | translate}}
                              </button>
                              <button (click)="openAgentDialog()"  (click)="this.trackService.pushEventTracking('navigationButton', 'MEET_AGENT_BUTTON')" nxPlainButton type="button" *ngIf="fromAgentPage=== true">
                                  <nx-icon
                                      class="buttonIcon"
                                      name="user-business-o"></nx-icon>
                                  {{'footer.meetAgent' | translate}}
                              </button>
                          </div>
                      </div>
                  </ng-container>
              </ng-container>
          </ng-container>
      </ng-container>
  </ng-container>
  <ng-container *ngIf="!footerWithPrice">
      <div *ngIf="outlet || rightButtonsList && rightButtonsList.length" class="app-footer__right-column fixed-width">
          <div class="app-footer_content">
              <ng-content></ng-content>
          </div>
          <div *ngIf="outlet" class="app-footer_content">
              <ng-container *ngComponentOutlet="outlet"></ng-container>
          </div>
          <ng-container *ngFor="let rightButton of rightButtonsList">
              <qbe-button  (click)="gmapsFindAddress()" [disabled]="disableObjectDetailsRoute()" *ngIf="(!rightButton.type || rightButton.type
                  ===
                  'button') && (forseDisable ||
                  getState(rightButton.disabled))" [mode]="rightButton.mode" (click)="activeFunction(forseDisable ||
                  getState(rightButton.disabled), rightButton.link)" class="app-footer__button
                  nextBtnStyle" (click)="invokeReCaptcha();
                  this.trackService.pushEventTracking('navigationButton','NEXT_BUTTON')">
                  <qbe-icon *ngIf="rightButton.icon" [icon]="rightButton.icon" class="app-footer__button-icon"></qbe-icon>
                  {{ rightButton.text | translate}}
              </qbe-button>
              <qbe-button (click)="gmapsFindAddress()" [disabled]="disableObjectDetailsRoute()" *ngIf="(!rightButton.type || rightButton.type
                  ===
                  'button') && !(forseDisable ||
                  getState(rightButton.disabled))" [mode]="rightButton.mode" (click)="activeFunction(forseDisable ||
                  getState(rightButton.disabled),rightButton.link )" class="app-footer__button
                  nextBtnStyle" (click)="invokeReCaptcha();
                  this.trackService.pushEventTracking('navigationButton','NEXT_BUTTON')">
                    <qbe-icon *ngIf="rightButton.icon" [icon]="rightButton.icon"
                        class="app-footer__button-icon"></qbe-icon>
                    {{ rightButton.text | translate}}
                </qbe-button>
                <nx-link *ngIf="rightButton.type === 'link'">
                    <a [routerLink]="rightButton.link"
                        (click)="invokeReCaptcha(); activeFunction(false, rightButton.link)">
                        {{ rightButton.text |
                        translate}}
                    </a>
                </nx-link>
            </ng-container>
        </div>

    </ng-container>



</div>

<br />

<ng-template #template1>

    <div class="container-fluid py-3">

        <form #form="ngForm">
            <div class="row mt-3">
                <div class="col-sm-12 mb-2">
                    <re-captcha id="recaptcha" name="recaptcha" #recaptcha="ngModel" [(ngModel)]="token1" required
                        [class.is-invalid]="recaptcha.invalid &&
                      (recaptcha.dirty || recaptcha.touched)"></re-captcha>
                    <div class="invalid-feedback">
                        <div>{{ 'footer.requiredField' | translate}}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mb-2">
                    <button type="button" class="btn btn-sm btn-primary" (click)="send1(form)">{{ 'footer.send' |
                        translate}}</button>
                </div>
            </div>
        </form>
    </div>

</ng-template>

<ng-template #ТhankYou>
  <h3 class="thankYou-Header">{{ 'callMeBack.thankYou' | translate}}</h3>
  <p class="thankYou-text">{{ 'callMeBack.contactYouText' | translate}}</p>
  <center>
      <img class="img-thankYou" aemNormalizeUrl src="/assets/img/illu@3x.svg" />
  </center>
</ng-template>
